export function dyannePlatformWorkshopCalculator( form_id ) {
    const formWrapper = document.querySelector('.workshop-form');
    const quantityField = document.querySelector('.ginput_appointment_quantity_input select');
    const totalsField = document.querySelector('.ginput_total');

    // Abort if one of the fields is not found.
    if (!formWrapper || !quantityField || !totalsField || !formWrapper.querySelector('#gform_wrapper_' + form_id)) {
        return;
    }

    console.log( 'workshop calculator loaded for form_id: ' + form_id );

    // Update totals (2 fields) by multiplying quantity with total.
    const updateTotal = () => {

        console.log('updateTotal');
        console.log('quantityField', quantityField.value);
        console.log('totalsField', totalsField.value);

        let updatedTotal = 0;
        // let currentTotal = totalsField.value;
        let currentTotal = formWrapper.querySelector('.time_slot').getAttribute('slot_cost');

        updatedTotal = parseFloat(currentTotal) * parseFloat(quantityField.value);
        updatedTotal = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(updatedTotal);
        totalsField.value = updatedTotal;

        setTimeout(
            function () {
                formWrapper.querySelector('.ginput_total').classList.remove('loading');      
            },
            300
        );
    };
    
    // Trigger the updateTotal function when the total or quantity fields changes.
    jQuery("body").on("change", ".ginput_appointment_cost_input, .ginput_appointment_quantity_input select", function () {
        formWrapper.querySelector('.ginput_total').classList.add('loading');
        
        setTimeout(
            function () {
                updateTotal();
            },
            300
        );
    });
}